import urls from '../api_urls/benefit'
import { _post } from '@/axios/request'

// 获取benefit列表
export function getTableData (params) {
  return _post(urls.GET_LIST, params)
}

// 新增benefit
export function saveBenefit (params) {
  return _post(urls.SAVE_BENEFIT, params)
}

// 获取benefit详情
export function getBenefitDetail (params) {
  return _post(urls.GET_BENEFIT_DETAIL, params)
}

// 更新benefit信息
export function updateBenefit (params) {
  return _post(urls.UPDATE_BENEFIT, params)
}

// 删除consumerBenefit
export function deleteBenifit (params) {
  return _post(urls.DELETE, params)
}

// 检验consumerBenefit是否在使用中
export function getInUse (params) {
  return _post(urls.IN_USE, params)
}



// WEBPACK FOOTER //
// ./src/axios/api/benefit.js